import { render, staticRenderFns } from "./PaymentMethod.html?vue&type=template&id=140664f4&scoped=true&"
import script from "./PaymentMethod.ts?vue&type=script&lang=ts&"
export * from "./PaymentMethod.ts?vue&type=script&lang=ts&"
import style0 from "./PaymentMethod.css?vue&type=style&index=0&id=140664f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140664f4",
  null
  
)

export default component.exports